<template>
    <div :style="style" class="all">
        <div class="head">
            <span v-html="$getConfigText(block.inner.title)"></span>
        </div>
        <div class="content">
            <div class="boxes" v-for="(item,index) in block.inner.boxList" :key="index">
                <span v-html="$getConfigText(item.title)"></span>
                <p v-html="$getConfigText(item.content)"></p>
            </div>
        </div>
    </div>
</template> 

<style lang='scss' scoped>
    .all{
        display: flex;
        flex-direction: column;
        align-items: center;
        .head{
            margin-top: 1.07rem;
            margin-bottom: 1.07rem;
            font-size: 0.64rem;
            line-height: 1.4;
            font-weight: bold;
        }
        .content{
            display: flex;
            flex-wrap: wrap;
            .boxes{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-left: 3.4%;
                margin-right: 3.4%;
                margin-bottom: 0.72rem;
                width: 43%;
                height: 4.32rem;
                border-top: 0.11rem solid var(--theme);
                border-radius: 0px 0px 5px 5px;
                box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.14);
                .num{
                    margin-bottom: 0.37rem;
                }
                span{
                    text-align: center;
                    font-size: 0.43rem;
                    line-height: 0.48rem;
                    font-weight: bold;
                }
                p{
                    text-align: center;
                    margin-top: 0.4rem;
                    font-size: 0.37rem;
                    line-height: 0.59rem;
                    color:#333;
                }
            }
        }
        
    }
</style>

<script>
export default {
    name:'MResearchPro',
    props:{
        block:Object,
    },     
    computed:{
        style(){
            return `background-color:${this.block.backColor};
                    color:${this.block.fontColor}`
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/templates/m-blocks/research-pro.vue